var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93.63,
    height: 92,
    viewBox: "0 0 93.63 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-circle-selected",
    transform: "translate(-1.985 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icongraphic",
    d: "M94.647,15.723l-.157.182S49.53,68.087,49.53,68.087a4,4,0,0,1-6.088-.032L29,50.929a7.991,7.991,0,0,1,.963-11.27l5.151,6.116S46.533,59.309,46.533,59.309L88.585,10.5a4,4,0,0,1,6.062,5.226ZM92.675,35.462l-1.307-4.506-6.4,6.648c.7,2.446,1.018,4.527,1.018,10.4a38,38,0,1,1-38-38A39.506,39.506,0,0,1,73.4,19.386l5.158-6.114A47.512,47.512,0,0,0,47.985,2a46,46,0,1,0,46,46C93.985,41.919,93.677,38.97,92.675,35.462Z",
    fill: "#58ab27"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleSelected);
export default __webpack_public_path__ + "static/media/circle-selected.e03fd268e3e721ad4080e63f75fb5243.svg";
export { ForwardRef as ReactComponent };